import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {EntityDescriptionResponseApiModel} from "./entity-description.response-api-model";
import type {EntityDescriptionSectionDomainModel} from "./section/entity-description.section.domain-model";

export class EntityDescriptionDataSource extends BaseDomainDataSource {
  sections: Array<EntityDescriptionSectionDomainModel>;

  constructor(apiModel: EntityDescriptionResponseApiModel, sections: Array<EntityDescriptionSectionDomainModel>) {
    super(apiModel);

    this.sections = sections;
  }
}